import styled from "styled-components";


export const SearchInputs = styled.div`
  width: 100%;
  .lui-select {
    width: 100%;
    height: auto;
    background-color: white;
  }

  margin-bottom: 5px;
`